import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authSlice } from "./auth";
import { uiSlice } from "./ui";

const persistConfig = {
  key: "root",
  storage: storage,
};

const appReducer = combineReducers({
  auth: authSlice.reducer,
  ui: uiSlice.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// config the store
const store = configureStore({
  preloadedState: {},
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export default store;
export { persistor };
